import type { ProductFilter } from '~/types/productFilter'

export function useAlgolia() {
  const getRefinements = (filtersForCategory: ProductFilter[]) => {
    const filters: any[] = []

    filtersForCategory.forEach((filter) => {
      if (filter.widget === 'refinementList') {
        filters.push(useAisRefinementList({
          attribute: filter.attributePath,
          showMore: true,
          showMoreLimit: 200,
          limit: 10
        }))
      }
      else if (filter.widget === 'toggle') {
        filters.push(useAisToggleRefinement({
          attribute: filter.attributePath,
          on: filter.attributeValue
        }))
      }
      else if (filter.widget === 'range') {
        filters.push(useAisRangeInput({
          attribute: filter.attributePath
        }))
      }
    })

    return filters
  }

  return {
    getRefinements
  }
}
